<div class="right-side p-5">
  <h2>Event Details</h2>
  <div class="section">
    <form [formGroup]="form">
      <!--<div class="row">
        <div class="col-md-3">
          <div class="card bg-gradient-primary box-shadow mb-4">
            <div class="card-body">
              <h5 class="card-title fs-5">Total Events</h5>
              <div class="d-flex align-items-center">
                <div class="fs-4">{{ totalEvents }}</div>
                <p class="card-text mt-2">
                  <button id="btnTotalEvents" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">
                    <i class="bi bi-person-plus ms-auto fs-4"></i>-->
      <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
      <!--</button>
              </p>
              <i class="fas fa-calendar-alt ms-auto fs-4"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-gradient-success box-shadow mb-4">
          <div class="card-body">
            <h5 class="card-title fs-5">Enrolled Successfully</h5>
            <div class="d-flex align-items-center">
              <div class="fs-4">{{ enrolledSuccessfully }}</div>
              <p class="card-text mt-2">
                <button id="btnEnrolledSuccessfully" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">
                  <i class="bi bi-person-plus ms-auto fs-4"></i>-->
      <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
      <!--</button>
              </p>
              <i class="bi bi-check-circle-fill ms-auto fs-4"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card bg-gradient-warning box-shadow mb-4">
          <div class="card-body">
            <h5 class="card-title fs-5">Attended Events</h5>
            <div class="d-flex align-items-center">
              <div class="fs-4">{{participantsAttended}}</div>
              <p class="card-text mt-2">
                <button id="btnAttendedEvents" class="btn-link bg-transparent border-0 text-white" (click)="CardRedirection($event)">
                  <i class="bi bi-person-plus ms-auto fs-4"></i>-->
      <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
      <!--</button>
                </p>
                <i class="bi bi-calendar-event ms-auto fs-4"></i>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <!--<hr />-->

      <button class="btn btn-primary" (click)="changeView('list')"><i class="fas fa-list"></i> List</button>
      <button class="btn btn-primary mx-1" (click)="changeView('calendar')"><i class="fas fa-calendar-alt"></i> Calendar</button>
      <button type="submit" class="btn btn btn-primary" (click)="onCardView()"><i class="fas fa-th-large"></i> Block</button>

      <div class="row mt-3">

        <!--<div class="row">
    <div class="text-end">
      <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
    </div>

  </div>-->

        <div *ngIf="currentView === 'list'" class="table-responsive">

          <div class="col-lg-12 col-sm-12">

            <div class="search-container">
              <div class="d-flex align-items-center flex-wrap gap-3">



                <!-- From Date -->
                <mat-form-field appearance="outline" class="mb-2 flex-grow-1" style="max-width: 200px;">
                  <mat-label>From Date</mat-label>
                  <input matInput [matDatepicker]="fromPicker" formControlName="fromDate" readonly>
                  <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                  <mat-datepicker #fromPicker (closed)="onDateChange()"></mat-datepicker>
                </mat-form-field>

                <!-- To Date -->
                <mat-form-field appearance="outline" class="mb-2 flex-grow-1" style="max-width: 200px;">
                  <mat-label>To Date</mat-label>
                  <input matInput [matDatepicker]="toPicker" formControlName="toDate"
                         [min]="form.get('fromDate')?.value" readonly>
                  <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                  <mat-datepicker #toPicker (closed)="onDateChange()"></mat-datepicker>
                </mat-form-field>


                <!-- Search -->
                <mat-form-field class="search-input flex-grow-1 mb-2" appearance="outline">
                  <mat-label>Search</mat-label>
                  <input matInput formControlName="searchControl" />
                </mat-form-field>

                <!-- Search Button -->
                <button class="btn btn-outline-secondary p-2 mx-1 mb-2" type="submit"
                        (click)="onSearchClick(form.get('searchControl')?.value ?? '')" id="btnSearch">
                  <i class="bi bi-search"></i>
                </button>
                <!-- Reset Button -->
                <button class="btn btn-outline-secondary p-2 mb-2" type="reset" (click)="resetPage()" id="btnReset">
                  <i class="bi bi-arrow-clockwise"></i>
                </button>
                <div style="display: flex; gap: 10px;">
                  <button class="btn btn-primary"
                          [disabled]="form.value.today"
                          (click)="onButtonClick('today')">
                    Today
                  </button>

                  <button class="btn btn-warning"
                          [disabled]="form.value.tomorrow"
                          (click)="onButtonClick('tomorrow')">
                    Tomorrow
                  </button>
                  <button (click)="exportToExcel()" type="button" class="btn btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
                </div>
              </div>
              <!-- Validation Message -->
              <div *ngIf="form.get('searchControl')?.invalid && (form.get('searchControl')?.touched || form.get('searchControl')?.dirty)">
                <small *ngIf="form.get('searchControl')?.errors?.['pattern']" class="text-danger">
                  Invalid search term.
                </small>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="eventDate" matSort matSortDirection="desc" matSortDisableClear>
              <ng-container matColumnDef="Sr.No">
                <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                <td mat-cell *matCellDef="let event"> {{event.rowNum}} </td>
              </ng-container>
              <ng-container matColumnDef="eventId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Id</th>
                <td mat-cell *matCellDef="let event" class="text-primary no-underline" style="cursor: pointer;" (click)="ViewEventDetails(event.eventId)"> {{event.eventId}} </td>
              </ng-container>
              <ng-container matColumnDef="eventDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let event"> {{event.eventDate}} </td>
              </ng-container>
              <ng-container matColumnDef="interventionName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Intervention</th>
                <td mat-cell *matCellDef="let event"> {{event.interventionName}} </td>
              </ng-container>
              <ng-container matColumnDef="interestName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Component</th>
                <td mat-cell *matCellDef="let event"> {{event.interestName}} </td>
              </ng-container>
              <ng-container matColumnDef="eventName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Name</th>
                <td mat-cell *matCellDef="let event"> {{event.eventName}} </td>
              </ng-container>
              <ng-container matColumnDef="nameOfOrganisation">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name of Organisation</th>
                <td mat-cell *matCellDef="let event"> {{event.nameOfOrganisation}} </td>
              </ng-container>
              <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Time</th>
                <td mat-cell *matCellDef="let event"> {{event.time}} </td>
              </ng-container>
              <ng-container matColumnDef="venueDetails">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Venue Details</th>
                <td mat-cell *matCellDef="let event"> {{event.venueDetails}} </td>
              </ng-container>
              <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef width="100px">Action</th>
                <td mat-cell *matCellDef="let event">
                  <ng-container *ngIf="isBeforeToday(event.eventDate)">
                    <button (click)="ViewEventDetails(event.eventId)" class="btn btn-primary btn-sm me-2 mt-1">
                      <i class="bi bi-eye"></i>
                      View
                    </button>
                  </ng-container>
                  <!--<ng-container *ngIf="event.eventStatus === 'completed' && event.AttendedCount>0">-->
                    <ng-container *ngIf="event.AttendedCount>0">
                      <div>
                        <button (click)="SubmitFeedback(event.eventId)" class="btn btn-info btn-sm mt-1">
                          <i class="bi bi-chat-dots"></i>
                          {{ event.SubmittedFeedback > 0? 'Feedback & Certificate':'Submit Feedback'}}
                        </button>
                      </div>
                    </ng-container>
                    <!--<ng-container *ngIf="event.eventStatus === 'completed' && event.AttendedCount>0 && event.SubmittedFeedback > 0">
    <div>
      <button (click)="downloadMSMECertificate(event.eventId)" class="btn btn-info btn-sm mt-1">
        <i class="bi bi-chat-dots"></i>
        Download Certificate
      </button>
    </div>
  </ng-container>-->
                    <ng-container *ngIf="isToday(event.eventDate)">
                      <button (click)="ViewEventDetails(event.eventId)" class="btn btn-primary btn-sm me-2 mt-1">
                        <i class="bi bi-eye"></i>
                        View
                      </button>

                      <button (click)="EnrollEvent(event)"
                              class="btn btn-success btn-sm me-2 mt-1"
                              *ngIf="event.IsUpcomingToday == 1">
                        <!--(click)="EnrollEvent(event.eventId)"-->
                        <i class="bi bi-check-circle"></i>
                        {{ event.Enrolled > 0 ? 'Edit/Enroll' : 'Enroll' }}
                      </button>


                      <div *ngIf="event.Enrolled > 0">
                        <button (click)="DownloadTicket(event.eventId)" class="btn btn-warning btn-sm me-2 mt-1">
                          <i class="bi bi-download"></i>
                          Download Ticket
                        </button>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="isTomorrowOrFuture(event.eventDate, event.time)">
                      <button (click)="ViewEventDetails(event.eventId)" class="btn btn-primary btn-sm me-2 mt-1">
                        <i class="bi bi-eye"></i>
                        View
                      </button>
                      <div>
                        <button (click)="EnrollEvent(event)" class="btn btn-success btn-sm me-2 mt-1">
                          <!--<button (click)="EnrollEvent(event.eventId)" class="btn btn-success btn-sm me-2 mt-1">-->
                            <!--*ngIf="!isEventWithin24Hours(event.eventDate, event.time)">-->
                            <i class="bi bi-check-circle"></i>
                            {{ event.Enrolled > 0 ? 'Edit/Enroll' : 'Enroll' }}
                          </button>
                      </div>
                      <div *ngIf="event.Enrolled > 0">
                        <button (click)="DownloadTicket(event.eventId)" class="btn btn-warning btn-sm me-2 mt-1">
                          <i class="bi bi-download"></i>
                          Download Ticket
                        </button>
                      </div>
                    </ng-container>
                    <div class="modal-backdrop" *ngIf="showPopup">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title">{{ popupTitle }}</h5>
                          <button type="button" class="close-button" (click)="closePopup()">
                            &times;
                          </button>
                        </div>
                        <div class="modal-body">
                          <p class="popup-message">{{ popupMessage }}</p>

                          <div *ngIf="pastEventsData.length > 0">
                            <h6>Past Event Details:</h6>
                            <ul class="event-list">
                              <li *ngFor="let event of pastEventsData">
                                <strong>Event Name:</strong> {{ event.EventName }}<br>
                                <strong>Event ID:</strong> {{ event.EventId }}<br>
                                <strong>Date:</strong> {{ event.EventDate | date:'mediumDate' }}<br>
                                <strong>Intervention:</strong> {{ event.InterventionName }}<br>
                                <strong>Interest:</strong> {{ event.InterestName }}<br>
                                <strong>IA Name:</strong> {{ event.NameOfOrganisation }}
                              </li>
                            </ul>
                          </div>
                          <div *ngIf="pastEventsData.length === 0 && popupMessage !== ''">
                            <p>No specific past event details were provided.</p>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" (click)="closePopup()">Close</button>
                        </div>
                      </div>
                    </div>
</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              Row shown when there is no matching data.
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>

              </tr>
            </table>

          </div>
          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [disabled]="disabled"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>
        </div>

        <div *ngIf="currentView === 'block'" class="row">
          <br />
          <div class="col-md-4 mb-3" *ngFor="let event of eventBlock">
            <br />
            <div class="event-block card p-3 event-min-height">
              <h4>{{ event.eventName }}</h4>
              <p><b>Date : </b>{{ transformDate(event.eventDate) | date:'dd/MM/yyyy' }}</p>
              <p><b>Time : </b>{{ event.time }}</p>
              <p><b>Component : </b>{{ event.interestName }}</p>
              <p><b>Venue : </b>{{ event.venueDetails }}</p>
              <p><b>Organizer : </b>{{event.nameOfOrganisation}}</p>
              <div>
                <ng-container *ngIf="isBeforeToday(event.eventDate)">
                  <button (click)="ViewEventDetails(event.eventId)" class="btn btn-primary btn-sm me-2 mt-1">
                    <i class="bi bi-eye"></i>
                    View
                  </button>
                </ng-container>
                <!--<ng-container *ngIf="event.eventStatus === 'completed' && event.AttendedCount>0">-->
                  <ng-container *ngIf="event.AttendedCount>0">
                    <div>
                      <button (click)="SubmitFeedback(event.eventId)" class="btn btn-info btn-sm mt-1">
                        <i class="bi bi-chat-dots"></i>
                        {{ event.SubmittedFeedback > 0? 'Feedback & Certificate':'Submit Feedback'}}
                      </button>
                    </div>
                  </ng-container>
                  <!--<ng-container *ngIf="event.eventStatus === 'completed' && event.AttendedCount>0">
    <div>
      <button (click)="SubmitFeedback(event.eventId)" class="btn btn-info btn-sm mt-1">
        <i class="bi bi-chat-dots"></i>
        Submit Feedback
      </button>
    </div>
  </ng-container>-->
                  <!--<ng-container *ngIf="event.eventStatus === 'completed' && event.AttendedCount>0 && event.SubmittedFeedback > 0">
    <div>
      <button (click)="downloadMSMECertificate(event.eventId)" class="btn btn-info btn-sm mt-1">
        <i class="bi bi-chat-dots"></i>
        Download Certificate
      </button>
    </div>
  </ng-container>-->
                  <ng-container *ngIf="isToday(event.eventDate)">
                    <button (click)="ViewEventDetails(event.eventId)" class="btn btn-primary btn-sm me-2 mt-1">
                      <i class="bi bi-eye"></i>
                      View
                    </button>
                    <div *ngIf="event.Enrolled > 0">
                      <button (click)="DownloadTicket(event.eventId)" class="btn btn-warning btn-sm me-2 mt-1">
                        <i class="bi bi-download"></i>
                        Download Ticket
                      </button>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="isTomorrowOrFuture(event.eventDate, event.time)">
                    <button (click)="ViewEventDetails(event.eventId)" class="btn btn-primary btn-sm me-2 mt-1">
                      <i class="bi bi-eye"></i>
                      View
                    </button>
                    <div>
                      <!--(click)="EnrollEvent(event.eventId)"-->
                      <button (click)="EnrollEvent(event)" class="btn btn-success btn-sm me-2 mt-1" *ngIf="!isEventWithin24Hours(event.eventDate, event.time)">
                        <i class="bi bi-check-circle"></i>
                        {{ event.Enrolled > 0 ? 'Edit/Enroll' : 'Enroll' }}
                      </button>
                    </div>
                    <div *ngIf="event.Enrolled > 0">
                      <button (click)="DownloadTicket(event.eventId)" class="btn btn-warning btn-sm me-2 mt-1">
                        <i class="bi bi-download"></i>
                        Download Ticket
                      </button>
                    </div>
                  </ng-container>
</div>
            </div>
          </div>
          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onCardPageChange($event)"
                         [length]="lengthBlock"
                         [pageSize]="pageSizeBlock"
                         [disabled]="disabledBlock"
                         [showFirstLastButtons]="showFirstLastButtonsBlock"
                         [pageSizeOptions]="pageSizeOptionsBlock"
                         [hidePageSize]="hidePageSizeBlock"
                         [pageIndex]="pageIndexBlock"
                         aria-label="Select page">
          </mat-paginator>
        </div>

        <!-- Calendar View (You can integrate a calendar component here) -->
        <div *ngIf="currentView === 'calendar'">
          <!-- Calendar logic will go here -->
          <!--<p>Calendar View - Coming soon</p>-->
          <app-full-calender></app-full-calender>
        </div>
      </div>
    </form>
  </div>
</div>
